
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getQaDecisionDataForArea",
      resolverType: "query",
      routePath: "/getQaDecisionDataForArea",
      httpMethod: "POST",
    });
  